import { Injectable } from "@angular/core";
import { IID_OL_ACCETTATO_KO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolAccettatoKoStore } from "./accettatoKo.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ACCETTAZIONE_NEGATIVA)
export class IIDolAccettatoKoQuery extends AbstractInterfaceDataQuery<IID_OL_ACCETTATO_KO> {

  constructor(protected store: IIDolAccettatoKoStore) {
    super(store);
  }
}
